import {Toast} from 'bootstrap';

export function showToast({ title = "Notification", body = "", type = "default", delay = 5000 } = {}) {
    // Ensure Bootstrap toast container exists
    let toastContainer = document.getElementById("global-toast-container");
    if (!toastContainer) {
        console.debug("[Toast] Toast container is missing.");
        return;
    }

    // Create the toast element
    const toast = document.createElement("div");
    toast.className = `toast hide toast fade`;
    toast.setAttribute("role", "alert");
    toast.setAttribute("aria-live", "assertive");
    toast.setAttribute("aria-atomic", "true");

    const iconType = () => {
        if (type === "success") {
            return "toast-success fa-solid fa-check-double";
        } else if (type === "warn") {
            return "toast-warning fa-solid fa-circle-exclamation"
        } else if(type === "error") {
            return "toast-danger fa-solid fa-circle-exclamation"
        }

        //default
        return "toast-primary fa-regular fa-bell";
    }
    // Toast content
    toast.innerHTML = `
        <div class="toast-header">
          <i class="toast-icons ${iconType()}" ></i>
          <strong class="me-auto">${title}</strong>
          <button class="btn-close" type="button" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body toast-dark">
          ${body}
        </div>
    `;


    // Prepend the toast to the container for newest-to-oldest stacking
    toastContainer.prepend(toast);

    // Initialize and show the toast using Bootstrap's Toast class
    const bootstrapToast = new Toast(toast);
    bootstrapToast.show();

    // Remove the toast from DOM after it's hidden
    toast.addEventListener("hidden.bs.toast", () => {
        toast.remove();
    });
}

export const notificationType = {
    SUCCESS: "success",
    WARN: "warn",
    ERROR: "error",
    DEFAULT: "default"
}
